import { TFunction } from "i18next";
import { AuditSource } from "../hooks/useAuditData";
import { demystifyError } from "@/utilities/error/demystifyError";
import { DeviceCapError } from "@/utilities/error/DeviceCapError";

/**
 * Body of the load-error alert. Too many vehicles in the filter: refreshing does not help, only a
 * narrower filter does, so the cap message replaces the "retry with refresh" advice.
 */
export function auditLoadErrorBody(
  t: TFunction,
  devicesError: unknown,
  failedSources: readonly (AuditSource | "devices")[],
): string {
  if (devicesError instanceof DeviceCapError) return demystifyError(t, devicesError);
  return t("logbookAudit.loadError.body", {
    sources: failedSources.map(source => t(`logbookAudit.loadError.sources.${source}`)).join(", "),
  });
}
